export default __webpack_public_path__ + "static/media/christian.3dc80c1d.jpg";